/* Global imports. */
import React from "react";

import KontentRichText from "@components/KontentRichText"

import KontentFieldRichText from "@models/kontent/KontentFieldRichText"

interface Props {
  richTextContent?: KontentFieldRichText;
  displayKeyline: boolean;
}

const ReusableRichText = ({ richTextContent, displayKeyline }: Props) =>  {
  const cssClass = displayKeyline ? "shadow-2xl rounded-md p-8 mt-8" : ""

  return ( <>
  {richTextContent && (
    <div className={`component--reusable-richtext ${cssClass}`}>
      <KontentRichText value={richTextContent} />
    </div>
  )}
  </>
  )
};

export default ReusableRichText;
